export default __webpack_public_path__ + "static/media/SF Compact Display UltraLight.34b9268c.ttf";